var render = function render(){var _vm=this,_c=_vm._self._c;return _c('range-slider',{attrs:{"max":100,"min":-100,"postfix":"%"},on:{"change":_vm.onChange},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }